"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYER_SESSION_RENEWAL_WINDOW_SECONDS = exports.PLAYER_SESSION_LIFETIME_SECONDS = exports.PLAYER_SESSION_MINIMUM_PROTOCOL_VERSION = exports.PLAYER_SESSION_PROTOCOL_VERSION = void 0;
exports.PLAYER_SESSION_PROTOCOL_VERSION = 2;
exports.PLAYER_SESSION_MINIMUM_PROTOCOL_VERSION = 1;
exports.PLAYER_SESSION_LIFETIME_SECONDS = 60 * 60;
exports.PLAYER_SESSION_RENEWAL_WINDOW_SECONDS = 10 * 60;
